



















































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import { EFacilityBlockableFeatures, EUserPermissions, IFacility } from '@zunta/configurations'
import { UserModule } from '@/store/modules/user.module'
import { FacilityModule } from '@/store/modules/facility.module'
import { ResidentModule } from '@/store/modules/resident.module'
import Api from '@/api'
import { User } from '@/classes/User'
import BatchSettings from '@/views/app/management/settings/pages/facility/batch/components/BatchSettings.vue'
import Card from '@/components/Card.vue'
import ReceiptOrderModal from '@/views/app/management/settings/pages/facility/batch/components/ReceiptOrderModal.vue'
import ReturnEnvelopeModal
  from '@/views/app/management/settings/pages/facility/batch/components/ReturnEnvelopeModal.vue'
import Status from '@/components/statuses/Status.vue'
import { EStatusType } from '@/components/statuses/EStatusType'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import ScrollView from '@/components/ScrollView.vue'
import StatusFacilityComplete from '@/components/statuses/StatusFacilityComplete.vue'
import Switcher from '@/components/Switcher.vue'
import { isFacilityFeatureBlocked } from '@/utils/facility/facilityFeatures'

@Component({
  components: {
    ScrollView,
    LoaderWrapper,
    Status,
    ReturnEnvelopeModal,
    ReceiptOrderModal,
    Card,
    BatchSettings,
    Icon,
    StatusFacilityComplete,
    Switcher
  }
})
export default class FacilityBatchSettings extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  EUserPermissions = EUserPermissions
  user: User = Api.getUser() as User
  EStatusType = EStatusType
  EFacilityBlockableFeatures = EFacilityBlockableFeatures

  facilityData: Partial<IFacility> = {}

  showReceiptOrderModal: boolean = false
  showReturnEnvelopeModal: boolean = false
  isLoading: boolean = false

  get selectedFacility (): IFacility {
    return this.$store.state.facility.selectedFacility
  }

  async mounted () {
    if (!this.selectedFacility) {
      return
    }
    if (this.isStatementGenAndMailBlocked && !this.user.isSystemAdmin()) {
      return this.$router.push({
        name: 'management-facilities-settings-information', params: { id: String(this.selectedFacility.id) }
      })
    }
    try {
      this.isLoading = true
      await Promise.all([
        this.residentModuleInstance.fetchResidentTypeOfContactList(this.selectedFacility.id as number),
        this.facilityModuleInstance.getFacilityPayerGroups(this.selectedFacility.id as number)
      ])
      this.$nextTick(this.setFacilityData)
    } finally {
      this.isLoading = false
    }
    this.$watch(() => (this.selectedRecipientOrder), () => {
      this.facilityModuleInstance.SET_FACILITY_COMPLETE_LEVEL([
        { type: 'batch', value: this.selectedRecipientOrder.length ? 100 : 0 }
      ])
    })
  }

  async save () {
    if (!this.selectedFacility) {
      return
    }

    if (!this.user.hasPermissionFor(EUserPermissions.EDIT_STATEMENT_SETTINGS)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Edit Statement Settings`,
        icon: 'warning'
      })
      return
    }

    await this.facilityModuleInstance.updateFacility({
      id: this.selectedFacility.id as number,
      data: this.facilityData
    })
  }

  getLabel (index: number) {
    if (index === 1) {
      return `${index}st place`
    } else if (index === 2) {
      return `${index}nd place`
    } else if (index === 3) {
      return `${index}rd place`
    }
    return `${index}th place`
  }

  addBatch () {
    const ref = this.$refs.batches

    if (ref) {
      (ref as any).initAdvancedEmptySettings()
    }
    this.$nextTick(() => {
      setTimeout(() => {
        const batch: any = document.body.querySelector('.facility-batch-setting:last-child')
        if (batch) {
          batch.scrollIntoView({ behavior: 'smooth' })
          const $editable = batch.querySelector('.editable')
          if ($editable) {
            setTimeout(() => {
              $editable.click()
            }, 1000)
          }
        }
      }, 200)
    })
  }

  get residentTypeOfContactList () {
    return this.$store.state.resident.typeOfContactList
  }

  get selectedRecipientOrder () {
    if (!this.residentTypeOfContactList || !this.selectedFacility.residentMailContacts) {
      return []
    }
    return this.selectedFacility.residentMailContacts
      .filter(selectedType => this.residentTypeOfContactList.includes(selectedType))
  }

  setFacilityData () {
    this.facilityData = JSON.parse(JSON.stringify(this.selectedFacility))
  }

  get isStatementGenAndMailBlocked () {
    return isFacilityFeatureBlocked(this.selectedFacility, EFacilityBlockableFeatures.MailAndGenStatements)
  }

  async updateFacilityBlockableFeatures (feature: EFacilityBlockableFeatures, toggle: boolean) {
    this.isLoading = true

    if (!EFacilityBlockableFeatures[feature]) {
      console.error('Invalid facility feature')
      return
    }

    let blockedFeatures: EFacilityBlockableFeatures[] = this.selectedFacility.blockedFeatures || []

    if (toggle && !blockedFeatures.includes(feature)) {
      blockedFeatures.push(feature)
    } else if (!toggle) {
      blockedFeatures = blockedFeatures.filter(feat => feat !== feature)
    }

    this.selectedFacility.blockedFeatures = blockedFeatures.length ? blockedFeatures : null
    this.setFacilityData()
    await this.save()

    this.isLoading = false
  }
}
